import React from 'react';
import intl from 'react-intl-universal';
import { Modal } from 'antd';
import { store } from 'Store/index';
import CommonPanel from '../CommonPanel/CommonPanel';
import './OpenFile.scss';
import '../common.scss';
export default class OpenFile extends React.Component {
  constructor(props) {
    super(props);

    // this.ModalTitle = intl.formatMessage({ id: 'OpenFileForPanel.Modal.Title' });

    this.state = {};
  }
  render() {
    let modalTitle;
    const { openFileDlg: {isForAi} } = store.appStore;
    const commonPanelProps = {
      operateType: 'open',
      openFileCallback: this.props.openFileCallback,
      onOpenFileForLocalComputer: this.props.onOpenFileForLocalComputer,
      onOpenFileForUrl: this.props.onOpenFileForUrl,
      activeKey: this.props.activeKey,
      onCancel: this.props.onCancel,
    };

    if (isForAi) {
      modalTitle = intl.get('OpenFileForPanel.Modal.TitleForAiPlugin');
    } else {
      modalTitle = intl.get('OpenFileForPanel.Modal.Title');
    }
    return (
      <Modal
        onCancel={this.props.onCancel}
        maskClosable={false}
        centered={true}
        className="open-file open-save-combine"
        width="970px"
        footer={null}
        visible={true}
        title={modalTitle}>
        <CommonPanel {...commonPanelProps} />
      </Modal>
    );
  }
}
